/**
 * @file memory.ts
 * @author Rapoo Device SDK Team
 * @date 2026-07-21
 * @description Telink 键盘 EEPROM 内存读写能力
 *
 * Telink 键盘使用 HID EEPROM 协议（0xa4 读 / 0xa5 写），
 * 控制通道走 0xba output / 0x08 feature report。
 */

import { ProtocolConfig } from '../../../types/protocol'
import { createCheckACK, createSendRead, createSendWrite } from '../../../utils/common'

/**
 * Telink 键盘 EEPROM 协议配置。
 *
 * - reportId: 0xba — Telink 键盘控制 Output Report
 * - featureReportId: 0x08 — Telink 键盘控制 Feature Report
 * - readCmd: [0xa4] — 读 EEPROM
 * - writeCmd: [0xa5] — 写 EEPROM
 */
export const TELINK_KEYBOARD_EEPROM_CONFIG: ProtocolConfig = {
  reportId: 0xba,
  featureReportId: 0x08,
  busy_ack_value: 0x02,
  read_ack_value: 0x01,
  readCmd: [0xa4],
  writeCmd: [0xa5],
}

export const checkACK = createCheckACK(TELINK_KEYBOARD_EEPROM_CONFIG)
export const sendRead = createSendRead(TELINK_KEYBOARD_EEPROM_CONFIG)
export const sendWrite = createSendWrite(TELINK_KEYBOARD_EEPROM_CONFIG)
